<template>
    <div :class="[$style.__register__online]" >
       <h5>{{ $t("messages.offline") }}</h5>
       <p :class="[$style.__intro]" v-html="$t('messages.intro')"></p>
       <form :class="['form-horizontal', $style.chat__form]"  :id="'formLiveChat'" @submit="checkForm">
            <div class="row-margin bdr-radius">
                <div class="input-comment">	
                    <textarea 
                        autofocus="autofocus" 
                        data-focus="data-focus"
                        v-model="msg" 
                        class="textarea" 
                        rows="2" 
                        :placeholder="[this.$t('textarea.send')]"
                        @keyup="checkWhiteSpace"
                    ></textarea>
                </div>
                <!-- <div :class="[$style.__chat__footer]">
                    <div :class="[$style.__chat__action]">
                        <div :class="[$style.__icon__camera]">
                            <a @click="uploadImage"  :class="['material-icons', $style.__icon]">camera_alt</a>
                        </div>
                        <div :class="[$style.__icon__attach]">
                            <a @click="attachFile" :class="['material-icons', $style.__icon]">attachment</a>
                        </div>
                        <div :class="[$style.__icon__setting]">
                            <a :class="['material-icons', $style.__icon, isSetting ? [$style.__active] : '']" @click="setting">settings</a>
                            <ul :class="[$style.__dropup__custom, isSetting ? [$style.__active] : '', sso == null ? [$style.__not__sso] : '']" aria-labelledby="notify-box">
                                <li v-if="sso != null"><a @click="rename"><span :class="['material-icons', $style.__icon]">person_outline</span><span>Đổi tên</span></a></li>
                                <li><a @click="confirmExit"><span :class="['material-icons', $style.__icon]">exit_to_app</span><span>Kết thúc hội thoại</span></a></li>
                            </ul>
                        </div>
                    </div>
                </div> -->
            </div>
            
            <ErrorList :errors="errors"></ErrorList>
            <div :class="['row-livechat', 'mt-2']">
                <ButtonSubmit></ButtonSubmit>
                <ButtonCancel @parentFunction="cancelButton"></ButtonCancel>
            </div>
       </form>
    </div>
</template>


<script>
    import InputName from '../blocks/InputName';
    import InputEmail from '../blocks/InputEmail';
    import ButtonSubmit from '../blocks/ButtonSubmit';
    import ButtonCancel from '../blocks/ButtonCancel';
    import ErrorList from '../blocks/ErrorList';
    import Validator from '@/functions/Validator';
    import Exit from '../blocks/Exit'

    let validator = new Validator;

    export default {
        props : {
            nameMemory : {
                type : String,
                default : ''
            }
        },
        data () {
            return {
                name: '',
                email : '',
                gender : '1',
                errors : [],
                isSetting : false,
                sso : [],
                messages : [],
                msg : '',
                cfmExit : false,
                room : '',
                token : '',
                contract : '',
                tokenOffline : ''

            }
        },
        components : {
            InputName, InputEmail, ButtonSubmit, ButtonCancel, ErrorList, Exit
        },
        watch: { 
            isClose: function(newVal, oldVal) { // watch it
                this.cfmExit = true;
            }
        },
        methods : {
            checkForm : function (event) {
                this.errors = [];
                var originName = this.name.split('+').join(' ');
                this.name = this.name.split('+').join(' ') + '%' + this.contract;
                
                if (this.name.trim().length <= 0) {
                    this.errors.push(this.$t("validator.name.null"));
                }
                
                if (!this.email) {
                    this.email = 'noeamil@fpt.com.vn';
                }

                if(this.msg.trim().length <= 0) {
                    this.errors.push(this.$t("validator.msg.null"));
                }

                // if(validator.hasOnlySpecialCharater(this.name)) {
                //     this.errors.push(this.$t("validator.name.special"));
                // }

                // if(validator.hasNumberCharacter(this.name)) {
                //     this.errors.push(this.$t("validator.name.number"));
                // }

                // if(validator.maxCharacter(this.name) != true) {
                //     this.errors.push(this.$t("validator.name.max", {max : validator.maxCharacter(this.name)}));
                // }

                // if(!validator.validateEmail(this.email) && this.email) {
                //     this.errors.push(this.$t("validator.email.example"));
                // }

                if(!this.errors.length) {
                    // this.$parent.initChatOffline(this.name, this.email, this.gender, this.msg);
                    this.$parent.initChatOfflineV2(this.name, this.email, this.gender, this.msg, originName);
                } else {
                    this.msg = '';

                }

                event.preventDefault()
            },
            getGender : function (event) {
                this.gender = event;
            },
            setting : function (event) {
                event.preventDefault()

                this.isSetting = !this.isSetting; 
            },
            uploadImage : function () {
                alert(this.$t("messages.comming"))
                //  Mở sau this.$refs.uploadImageFile.click() 
            },

            attachFile : function () {
                alert(this.$t("messages.comming"))
            },

            imagePreview : function(event) {
                var file = event.target.files;
                var url = window.URL.createObjectURL(file[0]);
                var attachment = event.target.files[0];
                this.imagesData.push({url : url, object : attachment})
            },

            closeChatHandle : function (event) {
                this.$emit('parentCloseChat', true)
            },
            rename : function () {
                // console.log('s')
                this.$router.replace('/rename');
            },
            confirmExit : function () {
                this.isSetting = false;
                this.cfmExit = true;
            },

            checkWhiteSpace : function (event) {
                event.target.value = event.target.value.trimLeft()
            },

            cancelButton : function (event) {
                this.errors = [];
                this.msg = '';
            },
        },
        created () {
            var sso = this.$cookies.get("fpt_sso");
            this.email = sso.email;
            this.name = sso.name;
            this.contract = sso.contract;
        },
        mounted () {
            var form = document.querySelector('#formLiveChat');
            if(form) {
                form.addEventListener('reset', function(event) {
                    var autofocusField = form.querySelector('[data-focus]');
                    if(autofocusField instanceof HTMLTextAreaElement) {
                        autofocusField.focus();
                    }
                });
            }
        }
        
    }
</script>

<style scoped module lang="scss">
    .__register__online {
        width: 100%;
        h5 {
            font-size: 13px !important;
            font-weight: 500 !important;
            line-height: 130% !important;
            margin-bottom: 15px !important;
        }
        .__intro {
            margin-top:1rem !important;
            color:#9A9A9A;
            font-size:13px;
            line-height: 150%;
        }
        .__chat__footer {
            width: 100%;
            height: 32px;
            display: table;
            padding: 0 15px 10px;
            .__icon__camera, .__icon__attach, .__icon__setting {
                display: table-cell;
                vertical-align: middle;
                width: 34px;
                cursor: pointer;
                text-decoration: none;
                a {
                    &:hover {
                        color: #F37021 !important
                    }
                }
                
            }
            .__icon__camera, .__icon__attach {
                padding-right: 10px;
            }
            .__icon__camera,  .__icon__setting{
                a {
                    font-size: 20px !important;
                }
            }
            .__icon__setting {
                position: relative;
                text-align :right;
                width : 100%;
                a {
                    &.__active  {
                        color : #F37021 !important;
                    }
                }
            }

            .__icon {
                color: #c7ccd1 !important;
                padding-top: 3px;
                text-decoration: none;
            }
            .__dropup__custom {
                display :none;
                position: absolute;
                list-style: none;
                top : -330%  !important;
                right: 0px;
                background: #fff;
                width: 170px;
                padding: 0px !important;
                border: 0px !important;
                -webkit-box-shadow: -1px 1px 5px 0px #d6d6d6;
                -moz-box-shadow: -1px 1px 5px 0px #d6d6d6;
                box-shadow: -1px 1px 5px 0px #d6d6d6;
                &.__not__sso {
                    top : -190% !important;
                }
                &.__active {
                    display :block;
                }
                li {
                    height : 47px;
                    &:hover {
                        a, .__icon {
                            color : #F37021 !important;
                        }
                    }
                    a {
                        padding: 10px 15px 16px;
                        display: table;
                        font-size : 13px !important;
                        font-weight : 410 !important;
                        text-decoration: none;
                        color: #323232 !important;
                        text-decoration: none !important;
                        span {
                            display: table-cell;
                            vertical-align: middle;
                            line-height: 23px;
                        }
                        .__icon {
                            width : 27px;
                            color : #19abff !important;
                            position: relative;
                            top: -3px;
                        }
                    }
                }
            }
        }
      
    }
    @media screen and (min-width: 769px) {
        .__register__online {
            h5 {
                font-size: 13px !important;
            }
            .__intro {
                font-size: 10px;
            }
        }
    }
</style>
<style lang="scss" scoped>
    .bdr-radius {
        background: #FCFCFC;
        border: 1px solid #E5E5E5;
        box-sizing: border-box;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
        border-radius: 6px;
        .input-comment {
            padding: 5px 15px 0;
            position: relative;
            .textarea {
                border: 0px;
                width: 100%;
                outline: none;
                resize: none !important;
                line-height: 19px !important;
                font-size: 16px !important;
                background: none;
            }
        }
        .footer {
            width: calc(100% - 30px);
            width: 100%;
            height: 32px;
            display: table;
            padding: 0 15px 10px;
            
            div {
                display: table-cell;
                vertical-align: middle;
                width: 34px;
                &:last-child{
                    width: auto;
                    text-align: right;
                    margin-right: 15px;
                }
                .ico-camera, .ico-settings {
                    font-size: 20px !important;
                }
                a.material-icons {
                    color: #c7ccd1 !important;
                    padding-top: 3px;
                    text-decoration: none !important;
                    
                }
            }
        }
    }
    @media screen and (min-width: 769px) {
        .bdr-radius {
            .input-comment {
                .textarea {
                    font-size: 13px !important;
                }   
            }
        }
    }
</style>